module.exports = __webpack_public_path__ + "static/media/CTLI_7-178w.ab43a0a6.png";